import { render } from "./SmallSpinner.vue?vue&type=template&id=2b87d822&scoped=true"
const script = {}

import "./SmallSpinner.vue?vue&type=style&index=0&id=2b87d822&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b87d822"]])

export default __exports__